import { addRtkQueryBridges, buildSlice, CommonState, LoadingState, Row } from '~libs/reduxUtils';
import { AwardAlert, AwardAlertVisibility } from '~weekly-planner/lib/common';

import { awardAlertsApi, typePrefix } from '~weekly-planner/actions/awardAlerts';

interface State extends CommonState<Row> {
  params: { [key: string]: any };
  awardAlertTypes: Array<AwardAlert>;
  awardAlertsVisibilities: AwardAlertVisibility;
  count?: number;
  rowsLoading: LoadingState;
  typeLoading: LoadingState;
}

const initialState: State = {
  loading: 'idle',
  typeLoading: 'idle',
  rowsLoading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
  params: { limit: 30 },
  awardAlertTypes: [],
  awardAlertsVisibilities: {},
};

const slice = buildSlice<State>(typePrefix, initialState, {
  extraReducers: (builder) => {
    addRtkQueryBridges<State, Row>(builder, [
      {
        endpoint: awardAlertsApi.endpoints.getAwardAlerts,
        mode: 'list',
        apply: (state, payload: any) => {
          state.loading = 'fulfilled';
          state.rowsLoading = 'fulfilled';
          const normalized = Array.isArray(payload)
            ? { rows: payload, total: payload.length }
            : (payload ?? { rows: [], total: 0 });
          state.rows = normalized.rows ?? [];
          state.count = normalized.total ?? 0;
          state.hasLoaded = true;
        },
        onPending: (state) => {
          state.rowsLoading = 'pending';
        },
        onRejected: (state) => {
          state.rowsLoading = 'error';
        },
      },
      {
        endpoint: awardAlertsApi.endpoints.getAwardAlertTypes,
        mode: 'list',
        apply: (state, payload) => {
          state.loading = 'fulfilled';
          state.typeLoading = 'fulfilled';
          state.awardAlertsVisibilities = payload.reduce((acc: AwardAlertVisibility, alert: AwardAlert) => {
            acc[alert.tag] = state.awardAlertsVisibilities[alert.tag] ?? true;
            return acc;
          }, {} as AwardAlertVisibility);

          state.awardAlertTypes = payload;
          state.hasLoaded = true;
        },
        onPending: (state) => {
          state.typeLoading = 'pending';
        },
        onRejected: (state) => {
          state.typeLoading = 'error';
        },
      },
    ]);
  },
  customActions: {
    setFilterOptions(state, action) {
      state.filterOptions = action.payload;
    },
    toggleAwardAlertVisibility(state, action) {
      const { key, toggle } = action.payload;
      state.awardAlertsVisibilities[key] = toggle;
    },
    clear(state) {
      state.rows = initialState.rows;
      state.params = initialState.params;
    },
  },
});

export const { clear, updateParams, setFilterOptions, toggleAwardAlertVisibility } = slice.actions;
export default slice.reducer;
